import { render, staticRenderFns } from "./IndexList06.vue?vue&type=template&id=30b3c6b8&scoped=true&"
import script from "./IndexList06.vue?vue&type=script&lang=js&"
export * from "./IndexList06.vue?vue&type=script&lang=js&"
import style0 from "./IndexList06.vue?vue&type=style&index=0&id=30b3c6b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3c6b8",
  null
  
)

export default component.exports